import { escapeRegExp } from "@/lib/Utils/escapeRegExp";
import { Fragment } from "react";

export function Highlighter({
  children,
  searchString,
  className,
}: {
  children: string;
  searchString: string;
  className?: string;
}) {
  const pattern = new RegExp(`(${escapeRegExp(searchString)})`, "i");
  const parts = children.split(pattern);

  if (searchString) {
    return (
      <span className={className}>
        {parts.map((part, index) =>
          pattern.test(part) ? (
            <mark key={index}>{part}</mark>
          ) : (
            <Fragment key={index}>{part}</Fragment>
          ),
        )}
      </span>
    );
  } else {
    return <span className={className}>{children}</span>;
  }
}
